const IconSummarise = () => {
  return (
    <g data-testid="icon-summarise">
      <path
        d="M16.5 12.5H21"
        stroke="currentColor"
        strokeWidth="1.2"
        strokeLinecap="round"
      />
      <path
        d="M14.5 7H21"
        stroke="currentColor"
        strokeWidth="1.2"
        strokeLinecap="round"
      />
      <path
        d="M7.08768 5.70141C7.30086 5.23251 7.96691 5.23251 8.18009 5.70141L9.30161 8.16828C9.36163 8.30032 9.46746 8.40614 9.59949 8.46616L12.0664 9.58768C12.5353 9.80086 12.5353 10.4669 12.0664 10.6801L9.59949 11.8016C9.46745 11.8616 9.36163 11.9675 9.30161 12.0995L8.18009 14.5664C7.96691 15.0353 7.30086 15.0353 7.08768 14.5664L5.96616 12.0995C5.90614 11.9675 5.80032 11.8616 5.66828 11.8016L3.20141 10.6801C2.73251 10.4669 2.73251 9.80086 3.20141 9.58768L5.66828 8.46616C5.80032 8.40614 5.90614 8.30032 5.96616 8.16828L7.08768 5.70141Z"
        fill="currentColor"
      />
      <path
        d="M11.5 18H21"
        stroke="currentColor"
        strokeWidth="1.2"
        strokeLinecap="round"
      />
    </g>
  );
};

export default IconSummarise;
